import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import image from '../img/bg5.jpg';
import { Container, Grid } from '@material-ui/core';
import { FeedCard } from '../components/Feed/FeedCard';
import { db } from '../firebase';
import { AuthContext } from '../contexts/AuthContext';
import Footer from '../core/Layout/Footer';
import { FeedInput } from '../components/Feed/FeedInput';
import 'react-photo-feed/library/style.css';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignText: 'center',
    justifyContent: 'center',
    height: '50vh',
    width: '100%',
    color: 'white',
    paddingTop: '100px',
  },
  inputCard: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 5px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '20px',
    },
  },
}));

export const Home = () => {
  const classes = useStyles();
  const [profileInfo, setProfileInfo] = useState<any>();
  const { currentUser } = useContext(AuthContext);
  const [mediaUrls, setMediaUrls] = useState<string[]>();
  const [column, setColumn] = useState(0);
  const [lastPost, setLastPost] = useState<any>();
  const [postsRenderInfo, setPostsRenderInfo] = useState<any>([]);
  const [postsSnapshots, setPostsSnapshots] = useState<any>([]);
  const [profiles, setProfiles] = useState<any>([]); //list of documents in profiles collection, doc id included, name = fName + lName

  const getDocumentByLimit = async (profiles,lastPostSnapshot) => {
    const postInfo = [];
    let posts;
    if(lastPost){
       posts = await db
          .collection('feed')
          .orderBy('uploaded_date', 'desc')
          .startAfter(lastPost)
          .limit(2)
          .get();
    }else{
       posts = await db
          .collection('feed')
          .orderBy('uploaded_date', 'desc')
          .startAt(lastPostSnapshot)
          .limit(2)
          .get();
    }

    posts.forEach((post) => {
      const post_id = post.id;
      const commentsInfo = [];
      let postData: any = {};
      post.data().comments.map((comment) =>
        profiles.map((profile) => {
          if (comment.commenter_id === profile.id) {
            commentsInfo.push({ dp: profile.dp, name: profile.name, comment: comment.comment });
          }
        })
      );
      profiles.map((profile) => {
        if (post.data().uploader_id === profile.id) {
          postData = { ...post.data(), ...profile, post_id: post_id };
        }
      });
      postData.comments = commentsInfo;
      postData.commentsData = post.data().comments;
      postInfo.push(postData);
    });
    setPostsSnapshots(posts.docs);
    if (postInfo.length !== 0) {
      // postInfo.reverse();
      setPostsRenderInfo((prev) => [...prev, ...postInfo]);
      setLastPost(posts.docs[posts.docs.length - 1]);
    }
    return postInfo;
  };

  useEffect(() => {
    const profile = async () => {
      const profileList = [];
      const profile = await db.collection('profile').doc(currentUser.uid).get();
      const profiles = await db.collection('profile').get();
      profiles.forEach((doc) => {
        profileList.push({
          name: `${doc.data().firstName} ${doc.data().lastName}`,
          dp: doc.data().dp_url,
          id: doc.id,
        });
      });
      const lastPostSnapshot = await db
          .collection('feed')
          .orderBy('uploaded_date', 'desc')
          .limit(1)
          .get();
      setProfiles(profileList);
      await getDocumentByLimit(profileList,lastPostSnapshot.docs[0]);
      setProfileInfo(profile.data());
    };
    profile();
  }, []);

  const setMediaHandler = (media) => {
    const imageGrid = [];
    if (media.length < 5) {
      setColumn(2);
    } else {
      setColumn(3);
    }
    media.map((url, index) => imageGrid.push({ id: index, src: url, bigSrc: url }));
    setMediaUrls(imageGrid);
  };
  if (!profileInfo) {
    return <div></div>;
  }
  return (
    <Grid container className={classes.container}>
      {/*Add a new post*/}
      <Grid item sm={12} md={6} className={classes.inputCard} style={{ width: '100%' }}>
        <Container>
          {profileInfo && (
            <FeedInput
              profileInfo={profileInfo}
              currentUser={currentUser}
              media={setMediaHandler}
            />
          )}
        </Container>
      </Grid>

      {/*Empty grid item*/}
      <Grid item sm={12} />

      {/*Posts*/}
      <Grid item sm={12} md={6} className={classes.inputCard}>
        <Container>
          {postsRenderInfo.length > 0 &&
            postsRenderInfo.map((post, index) => (
              <FeedCard postDetails={post} currentUser={currentUser} profileInfo={profileInfo} />
            ))}
        </Container>
      </Grid>
      <Grid item sm={12} style={{ textAlign: 'center' }}>
        <Button color="primary" onClick={() => getDocumentByLimit(profiles, postsSnapshots[postsSnapshots.length - 1])}>
          Show More
        </Button>
      </Grid>
      {/*Footer*/}
      <Grid item sm={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
